import { CardBody, CardContent, CardDesc, CardV2, Col } from '@si-armes/dsfr-react';
import React from 'react';
import * as PropTypes from 'prop-types';
import { entetesHistorique } from './constantes';

const CarteResultat = ({ historique }) => {
    return (
        <Col col={12} md={6} className="padding-carte">
            <CardV2 noEnlargeLink>
                <CardBody>
                    <CardContent>
                        <CardDesc>
                            {entetesHistorique.map((ti) => (
                                <p>
                                    <b>{ti.header} :</b> {historique[ti.field]}
                                </p>
                            ))}
                        </CardDesc>
                    </CardContent>
                </CardBody>
            </CardV2>
        </Col>
    );
};

CarteResultat.propTypes = {
    historique: PropTypes.object.isRequired,
};

export default CarteResultat;
